module.exports = __webpack_public_path__ + "static/media/checkin.ffc7e45c.svg";